import { OtherString } from '../otherString';
import { z } from 'zod';

export const AnnotationClassName = z.enum([
    'cigarettes',
    'redbull',
    'fresh_food_counter',
    'generic_coffee',
    'jack_daniels',
    'toffifee',
    'merci',
    'produce_net',
    'aptamil',
    'ariel',
    'head_and_shoulders',
    'nescafe',
    'razorblades',
]);
export type AnnotationClassName = z.infer<typeof AnnotationClassName>;

export const SnapshotChangeDetectionClassName = z.enum(['nothing', 'no_idea', 'added']);

/**
 * We sometimes want to "disable" annotation classes, in the sense that DSI users should no longer label them, e.g.:
 * - A class is removed from the models (labelling it in existing sessions would be a waste of time)
 * - A class is being recorded erroneously (e.g. bugs relating to Snapshot Change Detection class handling)
 */
export const DisabledAnnotationClassName = z.enum([
    ...AnnotationClassName.extract(['ariel', 'generic_coffee', 'head_and_shoulders', 'jack_daniels', 'nescafe', 'razorblades']).options,
    ...SnapshotChangeDetectionClassName.options,
] as const);
export type DisabledAnnotationClassName = z.infer<typeof DisabledAnnotationClassName>;

export const NonAnnotationClassName = z.enum(['loaded', 'bundle']);
export type NonAnnotationClassName = z.infer<typeof NonAnnotationClassName>;

export const ClassificationClassName = z.enum([...AnnotationClassName.options, ...NonAnnotationClassName.options]);
export type ClassificationClassName = z.infer<typeof ClassificationClassName>;

export const ClassificationClassFeedback = z.enum(['confirmed', 'edited', 'deleted']);
export type ClassificationClassFeedback = z.infer<typeof ClassificationClassFeedback>;

export const ClassificationClass = z.object({
    name: AnnotationClassName.or(OtherString),
    network: z.unknown().nullish(),
    probability: z.number(),
    feedback: ClassificationClassFeedback.nullish(),
});
export type ClassificationClass = z.infer<typeof ClassificationClass>;
